import type { PageGuide } from "../page-guide.js";

export const portalUsersGuide: PageGuide = {
  route: "/portal-users",
  version: 1,
  overviewArticleId: "portal-users-overview",
  steps: [
    {
      id: "choose-partner",
      title: "Choose the client portal",
      body: "The partner selected here is a portal that already exists. To create one, use **New partner portal**. The slug you type there is the new tenant. Copy documents from **l30**, not from the partner shown on this page.",
      anchorId: "portal-partner-selector",
    },
    {
      id: "invite",
      title: "Invite a portal user",
      body: "Use **Invite portal user** to send an audited magic-link invitation. Never insert portal users directly in the database.",
      anchorId: "portal-user-actions",
    },
    {
      id: "publish",
      title: "Publish useful content",
      body: "Open **Engagement plan → Share** to publish approved objects. You can also ask **Ask Insights** to list candidates, preview a publication, and carry it out after explicit confirmation.",
    },
  ],
  panels: [
    {
      anchorId: "portal-partner-selector",
      title: "Active partner",
      body: "This selection controls the tenant used by portal users, workspace settings, readiness, and publishing.",
      relatedArticleId: "portal-partner-onboarding",
    },
    {
      anchorId: "portal-user-actions",
      title: "Portal access",
      body: "New partner portal creates a tenant. Invite a user only after that tenant exists, and only into that partner. Do not invite them into the partner that happened to be selected when you opened this page.",
      relatedArticleId: "portal-users-overview",
    },
  ],
  guidedActions: [
    {
      id: "select-portal-partner",
      label: "Choose a partner portal",
      description: "Set the tenant before managing access or publishing.",
      when: (ctx) => !ctx.flags.partnerSelected,
      actionAnchorId: "portal-partner-selector",
    },
    {
      id: "invite-portal-user",
      label: "Invite a portal user",
      description: "Send the first audited magic-link invitation.",
      when: (ctx) => Boolean(ctx.flags.partnerSelected) && (ctx.counts.portalUsers ?? 0) === 0,
      actionAnchorId: "portal-user-actions",
      requiresRole: ["admin", "exec"],
    },
  ],
};
